import React from 'react';
import styled from 'styled-components';

import {
  colorBrandPrimaryPure,
  colorInterfaceDarkDown,
  colorInterfaceDarkDeep,
  colorInterfaceDarkUp,
  spacingStackXxs,
  spacingStackXs,
  spacingStackSm,
  spacingStackMd,
  spacingStackXxxl,
  fontSizeXxs,
  fontSizeXs,
  fontSizeSm,
  fontSizeMd,
  fontFamilyBase,
  fontFamilyHighlight,
  fontWeightRegular,
  fontWeightExtrabold,
} from '@useblu/ocean-tokens/web/tokens';

import { Button } from '@useblu/ocean-react';

import { breakpointTo, bpMedium } from 'tokens';

interface IButtonProps {
  className?: string;
  onClick: (e: React.ChangeEvent<HTMLInputElement>) => void;
  children: React.ReactNode;
}

export const Wrapper = styled.main`
  width: 100%;
  height: 100vh;

  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: ${spacingStackXxxl} 1fr 124px;
  overflow-x: hidden;
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Content = styled.div`
  width: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: auto 0px;

  @media ${breakpointTo(bpMedium)} {
    width: 100%;
    padding: ${spacingStackXs};
  }
`;

export const Img = styled.img`
  margin-bottom: 30px;
`;

export const Title = styled.span`
  text-align: center;
  font-family: ${fontFamilyHighlight};
  font-weight: ${fontWeightExtrabold};
  font-size: ${fontSizeMd};
  line-height: 26px;
  color: ${colorInterfaceDarkDeep};

  @media ${breakpointTo(bpMedium)} {
    font-size: ${fontSizeSm};
    line-height: 22px;
    padding: 0px ${spacingStackXs};
    color: ${colorBrandPrimaryPure};
  }
`;

export const Subtitle = styled.span`
  text-align: center;
  font-family: ${fontFamilyBase};
  font-weight: ${fontWeightRegular};
  font-size: ${fontSizeXs};
  line-height: 24px;
  color: ${colorInterfaceDarkDown};
  margin-top: ${spacingStackXs};

  @media ${breakpointTo(bpMedium)} {
    font-size: ${fontSizeXxs};
    line-height: 21px;
    padding: 0px ${spacingStackXs};
    margin-top: ${spacingStackXxs};
  }
`;

export const CustomButton = styled(Button).attrs(() => ({
  variant: 'primary',
}))<IButtonProps>`
  width: 243px;
  margin-top: ${spacingStackSm};
`;

export const RetryText = styled.span`
  text-align: center;
  font-family: 'Nunito Sans';
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  color: ${colorInterfaceDarkUp};
  margin-top: ${spacingStackMd};
`;

export const RetryButton = styled(Button).attrs(() => ({
  variant: 'primary',
}))<IButtonProps>`
  width: 243px;
  margin-top: ${spacingStackMd};
`;
